import "htmx.org";

if (document.getElementById("asse-back-button")) {
  import("./modules/backButton.mjs").then((module) => module.init());
}
if (document.getElementById("asse-filter-form")) {
  import("./modules/filterForm.mjs").then((module) => module.init());
}
